/**
 * Máscara de valor no estilo calculadora (digita centavos da direita para esquerda).
 * Entrada: evento ou string com qualquer caractere
 * Saída: "1.234,56"
 */
export const maskCurrency = (value) => {
  const digits = String(value).replace(/\D/g, '');
  if (!digits) return '';
  const cents = parseInt(digits, 10);
  return (cents / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Converte valor formatado de volta para float.
 * "1.234,56" → 1234.56
 */
export const parseCurrency = (formatted) => {
  if (!formatted) return 0;
  return parseFloat(String(formatted).replace(/\./g, '').replace(',', '.')) || 0;
};

/**
 * Formata um número para exibição no input ao editar um registro existente.
 * 1234.56 → "1.234,56"
 */
export const formatInitialAmount = (val) => {
  if (!val && val !== 0) return '';
  const num = parseFloat(val);
  if (!num) return '';
  return num.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
